export const categories = [
  {
    slug: 'anime',
    name: '动漫番剧',
    description: '最新番剧资讯、新番推荐、动画点评',
    icon: 'ri-tv-line',
    color: 'primary',
  },
  {
    slug: 'manga',
    name: '漫画天地',
    description: '热门漫画推荐、连载更新、漫画点评',
    icon: 'ri-book-open-line',
    color: 'accent',
  },
  {
    slug: 'light-novel',
    name: '轻小说',
    description: '精品轻小说阅读、书评推荐、新作速递',
    icon: 'ri-file-text-line',
    color: 'secondary',
  },
  {
    slug: 'cosplay',
    name: 'Cosplay',
    description: '超燃Cosplay作品、角色扮演教程、展会资讯',
    icon: 'ri-camera-lens-line',
    color: 'primary',
  },
  {
    slug: 'doujin',
    name: '同人创作',
    description: '同人画作、同人文、二次创作分享',
    icon: 'ri-paint-brush-line',
    color: 'accent',
  },
];

export const articles = [
  {
    id: 1,
    title: '【2026夏季新番】最值得追的10部番剧推荐，霸权预定来了！',
    slug: '2026-summer-anime-top-10',
    excerpt: '2026年夏季新番阵容豪华，《咒术回战 第三季》《鬼灭之刃 最终章》等大作云集。我们为你精心挑选了10部最值得追的新番，从热血战斗到治愈日常，总有一部适合你！',
    content: `<p>2026年夏季新番终于来了！这一季的阵容可以说是近年最强，多部超人气作品续作回归，同时也有不少令人惊喜的原创新作登场。下面就让91次元带你一起看看本季最值得关注的10部番剧吧！</p>
<h2>1. 咒术回战 第三季</h2>
<p>作为近年的现象级作品，《咒术回战》第三季毫无疑问是本季最受期待的作品。死灭回游篇正式展开，虎杖悠仁与伏黑惠的命运将走向何方？MAPPA的制作水准依然保持在线，战斗场面燃到爆炸。</p>
<h2>2. 鬼灭之刃 最终章（前篇）</h2>
<p>无限城篇终于来了！ufotable的作画依旧是天花板级别，每一帧都是壁纸。炭治郎与无惨的最终对决即将拉开帷幕，准备好纸巾吧！</p>
<h2>3. 葬送的芙莉莲 第二季</h2>
<p>治愈系的巅峰之作回归。芙莉莲与菲伦、修塔尔克的旅程继续，这一次魔法使考试的篇章更加扣人心弦。Madhouse精良的制作让这部作品每一集都像一部电影。</p>
<h2>4. 【我推的孩子】 第三季</h2>
<p>舞台剧篇章继续升温，阿库亚的复仇计划逐渐浮出水面。横枪メンゴ的原作加上动画工房的出色改编，让这部作品每一集都充满话题性。</p>
<h2>5. 孤独摇滚！第二季</h2>
<p>小波奇的成长故事继续！CloverWorks用极其有创意的演出方式，让这部四格漫画改编作品成为了现象级音乐番。新曲目值得期待！</p>
<h2>6. 迷宫饭 第二季</h2>
<p>美食与奇幻的完美融合！莱欧斯一行深入迷宫更深处，更多奇妙的魔物料理等你来品味。Trigger社独特的作画风格让这部作品魅力十足。</p>
<h2>7. 药屋少女的呢喃 第二季</h2>
<p>猫猫的宫廷推理故事继续！独特的中华风世界观加上精妙的推理剧情，让这部轻小说改编作品收获了大量粉丝。悠木碧的配音依旧出色。</p>
<h2>8. 怪兽8号 第二季</h2>
<p>日比野卡夫卡的战斗继续！Production I.G出品的精良3D与2D结合的战斗场面令人震撼。人类与怪兽的界限变得更加模糊，剧情走向引人入胜。</p>
<h2>9. 败犬女主太多了！</h2>
<p>本季最令人惊喜的原创新作！讲述多位"败犬"女主角在恋爱喜剧中的逆袭故事。角色塑造精妙，笑点与泪点并存，每一集都让人欲罢不能。</p>
<h2>10. 天国大魔境 第二季</h2>
<p>Production I.G的双线叙事神作回归。真流与斩子的旅程继续，两条时间线的秘密逐渐被揭开。石黑正数的原作充满了惊人的伏笔。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20summer%202026%20season%20collage%20with%20vibrant%20anime%20characters%20in%20action%20poses%2C%20colorful%20manga%20style%20illustration%20with%20warm%20lighting%2C%20clean%20composition%20on%20soft%20gradient%20background%2C%20anime%20promotional%20art%20style&width=800&height=450&seq=article-1-cover&orientation=landscape',
    category: 'anime',
    categoryName: '动漫番剧',
    author: '次元君',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20avatar%20portrait%20of%20manga%20character%20with%20glasses%20simple%20clean%20background%20soft%20colors&width=100&height=100&seq=avatar-author-1&orientation=squarish',
    date: '2026-08-01',
    readTime: '8分钟',
    tags: ['新番推荐', '2026夏季', '番剧排行'],
    views: 15820,
    likes: 2341,
    comments: 456,
    featured: true,
  },
  {
    id: 2,
    title: '《进击的巨人》完结一周年：这部神作给二次元世界留下了什么？',
    slug: 'attack-on-titan-legacy',
    excerpt: '距离《进击的巨人》动画完结已经一年，这部现象级作品对二次元文化产生了深远影响。从"献出心脏"到"塔塔开"，巨人的遗产远不止于流行语。',
    content: `<p>一年前的今天，《进击的巨人》动画最终季完结篇落下了帷幕。这部横跨十年的史诗巨作，不仅在商业上取得了空前的成功，更在文化层面上深深影响了一代二次元爱好者。今天，让我们一起回顾这部作品留下的宝贵遗产。</p>
<h2>一部改变行业格局的作品</h2>
<p>在《进击的巨人》之前，深夜动画的受众相对有限。但巨人的出现打破了这一格局，它将动画推向了主流视野。WIT STUDIO的精湛制作让每一场立体机动装置的战斗都令人窒息，MAPPA接手后的最终季虽然风格变化引发争议，但不可否认的是，两部制作公司都为这部作品倾注了全部心血。</p>
<h2>深刻的人文主题</h2>
<p>巨人的伟大之处在于它超越了简单的热血战斗。谏山创通过帕拉迪岛与马莱的对立，探讨了战争、种族、自由与仇恨的永恒主题。艾伦从一个想要驱逐所有巨人的少年，最终变成了发动地鸣的"恶魔"，这种人设的颠覆让所有观众都陷入了深深的思考。</p>
<h2>对二次元文化的深远影响</h2>
<p>"献出你的心脏"（心臓を捧げよ）成为了一个时代的标志性口号。"塔塔开"（戦え）从台词变成了网络流行语。巨人的成功也让更多资本看到了动画行业的潜力，推动了近年来动画制作预算的整体提升。</p>
<h2>音乐：泽野弘之的巅峰之作</h2>
<p>不能不提的是泽野弘之的音乐。《红莲的弓矢》《自由之翼》《The Rumbling》等曲目不仅是动画配乐的经典，更是独立于作品之外的文化现象。每一首主题曲都精准地捕捉了作品当下的情感基调。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20anime%20style%20wall%20scene%20with%20colossal%20titan%20silhouette%20and%20dramatic%20sunset%20sky%2C%20epic%20cinematic%20composition%2C%20dark%20atmospheric%20lighting%2C%20minimalist%20poster%20design&width=800&height=450&seq=article-2-cover&orientation=landscape',
    category: 'anime',
    categoryName: '动漫番剧',
    author: '动漫观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=anime%20style%20female%20avatar%20with%20short%20hair%20gentle%20smile%20simple%20pastel%20background&width=100&height=100&seq=avatar-author-2&orientation=squarish',
    date: '2026-07-28',
    readTime: '10分钟',
    tags: ['进击的巨人', '经典回顾', '动画产业'],
    views: 12450,
    likes: 1890,
    comments: 367,
    featured: true,
  },
  {
    id: 3,
    title: '《间谍过家家》剧场版全球票房突破3亿美元，安妮亚魅力席卷世界',
    slug: 'spy-family-movie-box-office',
    excerpt: '《间谍过家家 CODE: White》全球票房突破3亿美元大关，安妮亚的可爱魅力让全世界的观众都沦陷了。这部作品证明了合家欢动漫电影的巨大市场潜力。',
    content: `<p>据最新数据统计，《间谍过家家 CODE: White》剧场版动画的全球票房已经正式突破3亿美元，成为近年来最成功的动漫剧场版之一。这部由WIT STUDIO与CloverWorks联合制作的电影，让"哇库哇库"的安妮亚走遍了全世界的银幕。</p>
<h2>票房数字的背后</h2>
<p>3亿美元的全球票房对于一部日本动画电影来说是一个了不起的成就。这不仅仅是日本市场的成功——影片在北美、欧洲、东南亚等地区都取得了出色的成绩。安妮亚那标志性的"へっ"表情已经成为了全球通用的可爱符号。</p>
<h2>为什么间谍过家家能火遍全球？</h2>
<p>间谍过家家的成功绝非偶然。它巧妙地将间谍动作、家庭喜剧和温馨日常融为一体，创造了一种全新的叙事范式。洛伊德的酷帅、约尔的呆萌、安妮亚的天真烂漫，三个本无血缘关系的人组成的"伪装家庭"，却比任何真实的家庭都更加温暖。</p>
<h2>对中国市场的影响</h2>
<p>在中国，间谍过家家同样收获了海量粉丝。B站播放量轻松破亿，相关二创作品层出不穷。安妮亚的表情包更是渗透到了日常社交的每个角落，这种跨文化的影响力令人惊叹。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20Anya%20anime%20style%20illustration%20with%20warm%20family%20theme%20pink%20and%20golden%20color%20palette%2C%20playful%20composition%20with%20peanuts%20motif%2C%20soft%20lighting%20clean%20background&width=800&height=450&seq=article-3-cover&orientation=landscape',
    category: 'anime',
    categoryName: '动漫番剧',
    author: '次元君',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20avatar%20portrait%20of%20manga%20character%20with%20glasses%20simple%20clean%20background%20soft%20colors&width=100&height=100&seq=avatar-author-1&orientation=squarish',
    date: '2026-07-25',
    readTime: '6分钟',
    tags: ['间谍过家家', '剧场版', '票房'],
    views: 9870,
    likes: 1560,
    comments: 289,
    featured: false,
  },
  {
    id: 4,
    title: '《电锯人》第二季最新PV分析：蕾塞篇能否超越第一季的高度？',
    slug: 'chainsaw-man-season2-pv-analysis',
    excerpt: '《电锯人》第二季正式PV公开！蕾塞篇的期待值拉满，MAPPA能否吸取第一季的经验，带来更加出色的表现？让我们逐帧分析最新PV的每一个细节。',
    content: `<p>终于来了！MAPPA在最新发布会上公开了《电锯人》第二季——也就是蕾塞篇的首支完整PV。作为藤本树最具魅力的篇章之一，蕾塞篇承载着无数粉丝的期待。让我们一起来解析这支PV中透露的关键信息。</p>
<h2>蕾塞的形象还原度</h2>
<p>从PV中可以看到，蕾塞的设计非常还原漫画。那双清澈但又隐藏着秘密的眼睛，温柔中带着危险的微笑——MAPPA的角色设计团队显然对藤本树的画风做了深入研究。配音方面，官方尚未公布蕾塞的声优人选，但坊间传闻已经炸开了锅。</p>
<h2>战斗场景的进步</h2>
<p>第一季最受争议的就是3D在战斗场景中的使用。从PV来看，第二季在2D作画上的投入明显增加。炸弹恶魔变身的场景采用了手绘为主、3D辅助的方式，效果看起来比第一季的武士刀恶魔战要流畅得多。</p>
<h2>剧情走向预测</h2>
<p>蕾塞篇是整个《电锯人》故事中情感浓度最高的篇章之一。藤本树用短短十几话的篇幅，塑造了一个令人心碎的爱情故事。MAPPA能否在动画中还原这种"美好到令人窒息，然后在瞬间破碎"的感觉？这是第二季最大的看点。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chainsaw%20Man%20anime%20style%20Reze%20character%20illustration%20with%20dark%20red%20and%20black%20color%20scheme%2C%20dramatic%20explosion%20background%2C%20cinematic%20action%20composition%2C%20intense%20mood%20lighting&width=800&height=450&seq=article-4-cover&orientation=landscape',
    category: 'anime',
    categoryName: '动漫番剧',
    author: '动漫观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=anime%20style%20female%20avatar%20with%20short%20hair%20gentle%20smile%20simple%20pastel%20background&width=100&height=100&seq=avatar-author-2&orientation=squarish',
    date: '2026-07-22',
    readTime: '7分钟',
    tags: ['电锯人', 'MAPPA', 'PV分析'],
    views: 11340,
    likes: 1780,
    comments: 521,
    featured: true,
  },
  {
    id: 5,
    title: '《蓝色监狱》第二季：足球×生存游戏的极致化学反应',
    slug: 'blue-lock-season2-review',
    excerpt: '《蓝色监狱》第二季终于迎来了U-20日本代表战！洁世一与糸师凛的巅峰对决，将足球与生存游戏的融合推向了新的高度。',
    content: `<p>《蓝色监狱》第二季以U-20日本代表战为主线，将「最强的利己主义者」这个主题发挥到了极致。8bit的制作水准比第一季有了明显提升，尤其是在足球比赛场景的镜头调度上。</p>
<h2>角色塑造的深度进化</h2>
<p>洁世一的成长弧线是第二季最精彩的部分。从"拼图碎片"到"拼好后的完整画面"，他的空间感知能力进化让人惊叹。而糸师凛作为"天才"的孤独感也被刻画得入木三分。两人的理念碰撞不仅仅是球技的较量，更是足球哲学的对决。</p>
<h2>运动番的新范式</h2>
<p>《蓝色监狱》彻底颠覆了传统运动番"友情、努力、胜利"的套路。在这里，利己主义不是贬义词，而是成为世界第一前锋的必经之路。这种反传统的设定让它在众多运动番中脱颖而出。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Blue%20Lock%20anime%20soccer%20action%20scene%20with%20dynamic%20player%20poses%20on%20field%2C%20electric%20blue%20energy%20effects%2C%20intense%20competitive%20atmosphere%2C%20dramatic%20lighting%2C%20sports%20anime%20style&width=800&height=450&seq=article-5-cover&orientation=landscape',
    category: 'anime',
    categoryName: '动漫番剧',
    author: '次元君',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20avatar%20portrait%20of%20manga%20character%20with%20glasses%20simple%20clean%20background%20soft%20colors&width=100&height=100&seq=avatar-author-1&orientation=squarish',
    date: '2026-07-20',
    readTime: '6分钟',
    tags: ['蓝色监狱', '运动番', '足球'],
    views: 7650,
    likes: 1230,
    comments: 198,
    featured: false,
  },
  {
    id: 6,
    title: '《咒术回战》漫画最终章剧透预警：芥见下下的终局是否令人满意？',
    slug: 'jujutsu-kaisen-manga-finale',
    excerpt: '随着《咒术回战》漫画接近尾声，关于最终章的各种剧透和分析已经在网上广泛流传。让我们理性分析芥见下下为这个黑暗咒术世界画上的句号。',
    content: `<p>《咒术回战》漫画在连载六年多后终于迎来了最终章。芥见下下为五条悟、虎杖悠仁、宿傩等角色的命运画上了句号。这个结局引发了漫画读者的广泛讨论——有赞誉，也不乏争议。</p>
<h2>结局的核心主题</h2>
<p>《咒术回战》从始至终都在探讨一个核心命题：什么是"正确的死亡"？在咒术的世界里，死亡无处不在。芥见下下没有给读者一个皆大欢喜的结局，而是选择了一个更加真实、更加令人深思的收尾方式。</p>
<h2>角色的最终归宿</h2>
<p>每个主要角色的最终命运都在某种程度上呼应了他们的人物弧光。五条悟作为"最强"的孤独与责任、虎杖悠仁面对宿傩的挣扎、伏黑惠与家族诅咒的和解——这些线索在最终章都被一一收回。当然，有些角色的结局让读者感到意难平，但或许这正是芥见下下想要的效果。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20dark%20anime%20style%20illustration%20with%20cursed%20energy%20purple%20and%20black%20swirling%20effects%2C%20dramatic%20character%20silhouette%2C%20intense%20supernatural%20atmosphere%2C%20high%20contrast%20lighting&width=800&height=450&seq=article-6-cover&orientation=landscape',
    category: 'manga',
    categoryName: '漫画天地',
    author: '漫画发烧友',
    authorAvatar: 'https://readdy.ai/api/search-image?query=manga%20style%20male%20avatar%20with%20spiky%20hair%20determined%20expression%20clean%20background&width=100&height=100&seq=avatar-author-3&orientation=squarish',
    date: '2026-08-03',
    readTime: '9分钟',
    tags: ['咒术回战', '漫画结局', '芥见下下'],
    views: 18920,
    likes: 2780,
    comments: 892,
    featured: true,
  },
  {
    id: 7,
    title: '《间谍过家家》《坂本日常》领衔——2026年最值得期待的10部漫画',
    slug: '2026-must-read-manga',
    excerpt: '2026年漫画界精彩纷呈！从《间谍过家家》的最新剧情到《坂本日常》的动画化前夕，我们为你盘点今年最值得追的10部漫画作品。',
    content: `<p>2026年的漫画界可以说是百花齐放。老牌作品持续发力，新锐作品异军突起，还有多部人气漫画即将迎来动画化。下面是91次元为你精选的10部今年必追漫画！</p>
<h2>1. 间谍过家家</h2>
<p>远藤达哉的这部现象级作品在2026年依然保持着极高的水准。洛伊德、约尔和安妮亚的"家庭生活"不断面临着新的挑战，剧情在温馨日常和间谍动作之间切换自如。</p>
<h2>2. 坂本日常</h2>
<p>铃木祐斗的这部作品即将在2026年秋季迎来动画化！曾经的最强杀手坂本太郎退休后变成便利店老板的设定既搞笑又热血。动画化消息一出，漫画销量暴涨。</p>
<h2>3. 怪兽8号</h2>
<p>松本直也的这部漫画在动画化后人气飙升。第二季播出前，漫画中的剧情已经进入了更加激烈的篇章，日比野卡夫卡的秘密即将被更多人知晓。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=manga%20collection%20display%20with%20various%20Japanese%20comic%20book%20covers%20arranged%20artistically%2C%20warm%20lighting%2C%20cozy%20reading%20atmosphere%2C%20colorful%20spines%2C%20bibliophile%20aesthetic&width=800&height=450&seq=article-7-cover&orientation=landscape',
    category: 'manga',
    categoryName: '漫画天地',
    author: '漫画发烧友',
    authorAvatar: 'https://readdy.ai/api/search-image?query=manga%20style%20male%20avatar%20with%20spiky%20hair%20determined%20expression%20clean%20background&width=100&height=100&seq=avatar-author-3&orientation=squarish',
    date: '2026-07-30',
    readTime: '7分钟',
    tags: ['漫画推荐', '2026', '坂本日常'],
    views: 8320,
    likes: 1340,
    comments: 215,
    featured: false,
  },
  {
    id: 8,
    title: '《地狱乐》第二季制作决定！画眉丸的极乐净土之旅继续',
    slug: 'jigokuraku-season2-announcement',
    excerpt: 'MAPPA官方正式宣布《地狱乐》第二季制作决定！画眉丸与佐切的仙药寻找之旅即将继续，更多神仙与天仙的战斗即将展开。',
    content: `<p>好消息！MAPPA在最新一期《少年Jump+》上正式公布了《地狱乐》第二季的制作决定。这部由贺来友治创作、MAPPA改编的暗黑奇幻作品在播出第一季时就以其独特的美术风格和深刻的哲学思考获得了广泛好评。</p>
<h2>第二季的剧情展望</h2>
<p>随着画眉丸一行深入蓬莱仙岛的内部，他们将会遇到更多天仙级别的敌人。贺来友治在原作中构建了一个极其宏大的"极乐净土"世界观，而第二季将揭开这个世界更深的秘密。天仙莲的真相、画眉丸妻子的下落——这些谜团都将在新的篇章中揭晓。</p>
<h2>制作阵容</h2>
<p>牧田佳织导演确认回归，角色设计久木晃嗣也继续担任。MAPPA表示第二季在动作场景上将投入更多资源。值得期待！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Hells%20Paradise%20anime%20style%20dark%20fantasy%20island%20landscape%20with%20mystical%20plants%20and%20flowers%2C%20ethereal%20lighting%2C%20mysterious%20atmosphere%2C%20Japanese%20mythology%20inspired&width=800&height=450&seq=article-8-cover&orientation=landscape',
    category: 'manga',
    categoryName: '漫画天地',
    author: '动漫观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=anime%20style%20female%20avatar%20with%20short%20hair%20gentle%20smile%20simple%20pastel%20background&width=100&height=100&seq=avatar-author-2&orientation=squarish',
    date: '2026-07-18',
    readTime: '5分钟',
    tags: ['地狱乐', 'MAPPA', '第二季'],
    views: 6780,
    likes: 980,
    comments: 134,
    featured: false,
  },
  {
    id: 9,
    title: '轻小说推荐：2026年上半年最值得阅读的5部新作',
    slug: '2026-light-novel-recommendations',
    excerpt: '2026年上半年轻小说界涌现了不少令人惊喜的新作。从异世界转生到校园恋爱，我们精选了5部品质上乘的新作轻小说推荐给你。',
    content: `<p>轻小说作为二次元文化的重要载体，每年都会涌现出大量新作。在2026年上半年，有几部新作格外引人注目。无论你是异世界爱好者还是校园恋爱党，这份书单都能满足你的阅读需求。</p>
<h2>1.《失落的星之歌》</h2>
<p>讲述在人类已经移居太空的未来，一位少女歌姬通过歌声与外星文明交流的科幻故事。作者对音乐与情感的描写细腻动人，插图由知名画师"绯月"负责。</p>
<h2>2.《魔王城的不动产》</h2>
<p>魔王被打倒后，魔王城被改造成了豪华公寓。身为前魔王军四天王之一的主角，现在是一名不动产经纪人。这部作品将奇幻与职场喜剧巧妙融合。</p>
<h2>3.《图书馆的魔女与最后的书页》</h2>
<p>在魔法即将消亡的世界里，一位盲眼魔女守护着世界上最后的魔法图书馆。治愈系的叙事风格加上精致的文笔，让人读完心生温暖。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20light%20novel%20books%20stack%20with%20anime%20style%20illustration%20covers%2C%20warm%20cozy%20reading%20nook%20with%20soft%20lamp%20light%2C%20aesthetic%20book%20photography%2C%20gentle%20atmosphere&width=800&height=450&seq=article-9-cover&orientation=landscape',
    category: 'light-novel',
    categoryName: '轻小说',
    author: '轻小说控',
    authorAvatar: 'https://readdy.ai/api/search-image?query=anime%20style%20girl%20avatar%20with%20long%20hair%20reading%20book%20glasses%20gentle%20smile%20pastel%20background&width=100&height=100&seq=avatar-author-4&orientation=squarish',
    date: '2026-07-15',
    readTime: '8分钟',
    tags: ['轻小说推荐', '2026', '新作'],
    views: 5430,
    likes: 890,
    comments: 167,
    featured: false,
  },
  {
    id: 10,
    title: '《Re：从零开始的异世界生活》轻小说第40卷发售——菜月昴的最终试炼',
    slug: 'rezero-volume40-review',
    excerpt: '长月达平的史诗级轻小说《Re：从零开始的异世界生活》第40卷正式发售。菜月昴面对迄今为止最残酷的死亡回归循环，命运的齿轮加速转动。',
    content: `<p>《Re：从零开始的异世界生活》第40卷在本周正式发售。长月达平用近十年的时间为读者构建了一个关于"死亡回归"的宏大叙事，而第40卷标志着故事进入了最终阶段。</p>
<h2>第40卷的核心剧情</h2>
<p>在第40卷中，菜月昴面对的是前所未有的困境。大罪司教们的行动进入了关键阶段，而艾米莉亚阵营必须在极其有限的信息下做出抉择。一直以来支撑着昴的"死亡回归"能力，在这一卷中也出现了意想不到的变化。</p>
<h2>角色关系的深化</h2>
<p>蕾姆的苏醒是近期最大的看点之一。她与昴之间的羁绊在这一卷中被重新定义。与此同时，贝阿特丽斯的角色也有了重大发展。长月达平将每个角色的情感线都处理得非常细腻。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Re%20Zero%20anime%20style%20fantasy%20world%20with%20magical%20atmosphere%2C%20silver%20haired%20heroine%20in%20mystical%20forest%2C%20ethereal%20light%20particles%2C%20dreamy%20color%20palette%2C%20soft%20focus&width=800&height=450&seq=article-10-cover&orientation=landscape',
    category: 'light-novel',
    categoryName: '轻小说',
    author: '轻小说控',
    authorAvatar: 'https://readdy.ai/api/search-image?query=anime%20style%20girl%20avatar%20with%20long%20hair%20reading%20book%20glasses%20gentle%20smile%20pastel%20background&width=100&height=100&seq=avatar-author-4&orientation=squarish',
    date: '2026-08-02',
    readTime: '7分钟',
    tags: ['Re:从零开始', '轻小说', '长月达平'],
    views: 7820,
    likes: 1450,
    comments: 312,
    featured: true,
  },
  {
    id: 11,
    title: '轻小说改编动画的成功秘诀：从《无职转生》到《药屋少女》看IP运营',
    slug: 'light-novel-anime-adaptation-secrets',
    excerpt: '为什么有些轻小说改编动画能成为现象级作品，而有些却默默无闻？从《无职转生》《药屋少女》的成功中，我们总结出了几个关键要素。',
    content: `<p>近年来，轻小说改编动画占据了每季新番的半壁江山。其中，《无职转生》《药屋少女的呢喃》等作品不仅获得了商业成功，更在口碑上赢得了广泛认可。它们的成功并非偶然。</p>
<h2>制作资源的投入</h2>
<p>《无职转生》是Studio Bind——一家专门为这部作品成立的动画公司——倾力打造的作品。这种级别的资源投入在轻小说改编中极为罕见。精良的制作质量是让观众买单的基础。</p>
<h2>原作的坚实基础</h2>
<p>《药屋少女的呢喃》之所以成功，很大程度上得益于日向夏原作中扎实的世界观和精妙的推理设计。好的改编离不开好的原作，这是不变的真理。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=anime%20production%20studio%20workspace%20with%20storyboards%20and%20concept%20art%20on%20walls%2C%20creative%20atmosphere%2C%20warm%20lighting%2C%20artistic%20workspace%2C%20professional%20animation%20studio&width=800&height=450&seq=article-11-cover&orientation=landscape',
    category: 'light-novel',
    categoryName: '轻小说',
    author: '次元君',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20avatar%20portrait%20of%20manga%20character%20with%20glasses%20simple%20clean%20background%20soft%20colors&width=100&height=100&seq=avatar-author-1&orientation=squarish',
    date: '2026-07-12',
    readTime: '9分钟',
    tags: ['轻小说', '动画改编', 'IP运营'],
    views: 4560,
    likes: 720,
    comments: 98,
    featured: false,
  },
  {
    id: 12,
    title: '2026 ChinaJoy Cosplay大赛全程回顾：神仙打架的视觉盛宴',
    slug: '2026-chinajoy-cosplay-review',
    excerpt: '2026 ChinaJoy Cosplay大赛圆满落幕！本届大赛参赛作品质量创历史新高，从《原神》到《崩坏：星穹铁道》，各路神仙Coser带来了令人叹为观止的表演。',
    content: `<p>一年一度的ChinaJoy Cosplay大赛再次点燃了上海的夏天。2026年的比赛规模和质量都达到了新的高度，来自全国各地的顶尖Coser齐聚一堂，为观众呈现了一场视觉盛宴。</p>
<h2>最佳表演奖：《原神》雷电将军</h2>
<p>获得本届最佳表演奖的是来自广州的Coser"星野琉璃"带来的雷电将军cosplay。她不仅在服装道具上做到了几乎100%的还原，更通过精心编排的剑舞表演，完美诠释了雷电将军的威严与美感。</p>
<h2>最佳道具奖：《艾尔登法环》玛莲妮亚</h2>
<p>"铁匠工坊"团队耗时三个月打造的玛莲妮亚全套盔甲与义手刀，在细节上令人叹为观止。每一个金属部件的做旧处理都经得起特写镜头的考验。</p>
<h2>人气王：《崩坏：星穹铁道》卡芙卡</h2>
<p>毫无疑问，今年ChinaJoy最受欢迎的cos角色非卡芙卡莫属。她的优雅与神秘感被多位Coser以不同的方式诠释，每一位都有自己独特的魅力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=cosplay%20event%20stage%20with%20elaborate%20anime%20costumes%20and%20dramatic%20lighting%2C%20professional%20cosplay%20competition%20scene%2C%20colorful%20stage%20effects%2C%20energetic%20convention%20atmosphere&width=800&height=450&seq=article-12-cover&orientation=landscape',
    category: 'cosplay',
    categoryName: 'Cosplay',
    author: 'Cosplay达人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cosplay%20style%20avatar%20with%20colorful%20wig%20and%20makeup%20cute%20expression%20pastel%20background&width=100&height=100&seq=avatar-author-5&orientation=squarish',
    date: '2026-08-04',
    readTime: '10分钟',
    tags: ['ChinaJoy', 'Cosplay', '大赛'],
    views: 14200,
    likes: 2560,
    comments: 678,
    featured: true,
  },
  {
    id: 13,
    title: 'Cosplay入门完全指南：从零开始打造你的第一个Cos服',
    slug: 'cosplay-beginner-guide',
    excerpt: '想入坑Cosplay但不知从何开始？这份从选角、道具制作到化妆技巧的完全指南，帮你开启Cosplay之旅。零基础也能轻松上手！',
    content: `<p>很多二次元爱好者都梦想着能够Cosplay自己喜欢的角色，但面对复杂的服装和道具往往望而却步。其实，Cosplay并没有想象中那么遥不可及。这份指南将从最基础的步骤开始，带你一步步入门。</p>
<h2>第一步：选择合适的角色</h2>
<p>初学者建议从服装相对简单的角色开始。校服、日常装扮的角色是不错的起步选择。避免一开始就挑战盔甲类或大型道具的角色。《鬼灭之刃》的校服炭治郎、《青春猪头少年》的角色都是很好的入门之选。</p>
<h2>第二步：获取服装的途径</h2>
<p>有三种主要方式：购买成品（淘宝等平台有很多选择）、定制（找裁缝按你的尺寸制作）、自己制作（最有成就感但最耗时）。初学者建议先购买成品，等积累经验后再尝试定制或自制。</p>
<h2>第三步：化妆技巧</h2>
<p>Cosplay妆容的重点在于：底妆要干净、眼妆要夸张、修容要到位。多看B站上的Cos妆教程，多加练习。假睫毛和美瞳是提升还原度的关键道具。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=cosplay%20making%20process%20workspace%20with%20sewing%20machine%20fabric%20and%20costume%20pieces%2C%20creative%20DIY%20atmosphere%2C%20warm%20lighting%2C%20crafting%20scene%2C%20organized%20workspace&width=800&height=450&seq=article-13-cover&orientation=landscape',
    category: 'cosplay',
    categoryName: 'Cosplay',
    author: 'Cosplay达人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cosplay%20style%20avatar%20with%20colorful%20wig%20and%20makeup%20cute%20expression%20pastel%20background&width=100&height=100&seq=avatar-author-5&orientation=squarish',
    date: '2026-07-10',
    readTime: '12分钟',
    tags: ['Cosplay入门', '教程', '新手'],
    views: 10240,
    likes: 1890,
    comments: 445,
    featured: false,
  },
  {
    id: 14,
    title: '同人创作推荐：2026年最令人惊艳的10组同人画作',
    slug: '2026-best-doujin-artworks',
    excerpt: '在Pixiv和Twitter上，2026年涌现了大量令人惊艳的同人画作。从《原神》到《明日方舟》，我们精选了10组不容错过的同人艺术作品。',
    content: `<p>同人创作是二次元文化中最具活力的部分之一。2026年，在Pixiv、Twitter等平台上，来自全球各地的画师们创作了无数令人惊叹的同人作品。下面是我们精选的10组年度最佳。</p>
<h2>1. 「星穹之下」——《崩坏：星穹铁道》系列</h2>
<p>画师"銀河鉄道"创作的星穹铁道同人系列，以电影海报般的构图和光影处理令人惊艳。每一张都仿佛是一帧精心设计的动画电影截图。</p>
<h2>2. 「提瓦特的四季」——《原神》系列</h2>
<p>画师"風の旅人"以四季为主题创作的原神同人系列，用水彩风格将蒙德、璃月、稻妻、须弥的美景与角色完美融合。色彩运用极为出色。</p>
<h2>3. 「罗德岛的日常」——《明日方舟》系列</h2>
<p>画师"鉱石病"的四格漫画系列，以轻松幽默的方式展现了罗德岛干员们的日常生活。画风可爱，笑点满满。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=digital%20art%20illustration%20gallery%20display%20with%20anime%20style%20fan%20art%20on%20screens%2C%20colorful%20vibrant%20compositions%2C%20creative%20studio%20atmosphere%2C%20artistic%20workspace&width=800&height=450&seq=article-14-cover&orientation=landscape',
    category: 'doujin',
    categoryName: '同人创作',
    author: '同人鉴赏家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=digital%20artist%20avatar%20with%20stylus%20pen%20creative%20look%20simple%20background&width=100&height=100&seq=avatar-author-6&orientation=squarish',
    date: '2026-07-08',
    readTime: '6分钟',
    tags: ['同人画作', 'Pixiv', '年度推荐'],
    views: 8910,
    likes: 1670,
    comments: 234,
    featured: false,
  },
  {
    id: 15,
    title: '同人小说的魅力：为什么二次元爱好者如此热衷二次创作？',
    slug: 'doujin-fiction-appeal',
    excerpt: '从AO3到Lofter，同人小说的创作和阅读已经成为二次元文化中不可忽视的一部分。我们探讨了同人小说为何拥有如此强大的生命力。',
    content: `<p>在LOFTER、AO3等平台上，每天都有数以万计的同人小说被创作和阅读。为什么二次元爱好者如此热衷于这种"二次创作"？同人小说的魅力究竟在哪里？</p>
<h2>填补原作空白</h2>
<p>每一部优秀的作品都会留下许多"空白"——未展开的支线剧情、一笔带过的角色背景、甚至是有意留下的开放式结局。同人小说正是填补这些空白的最佳方式。当原作的结局让你意难平时，一篇精心创作的同人文可以给你心灵的慰藉。</p>
<h2>角色关系的重新探索</h2>
<p>同人小说允许创作者从不同角度探索角色之间的关系。在原作中未能实现的互动，在同人世界里都可以自由展开。这种创作自由正是同人最大的魅力。</p>
<h2>创作社区的温暖</h2>
<p>同人创作不仅仅是个人的表达，更是一种社区的联结。读者与作者之间的互动、评论区的讨论、联文活动的热情，这些都构成了同人文化独特的温度。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=cozy%20writing%20desk%20with%20laptop%20notebook%20and%20warm%20lamp%20light%2C%20creative%20writing%20atmosphere%2C%20anime%20posters%20on%20wall%2C%20soft%20warm%20lighting%2C%20writer%20workspace&width=800&height=450&seq=article-15-cover&orientation=landscape',
    category: 'doujin',
    categoryName: '同人创作',
    author: '同人鉴赏家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=digital%20artist%20avatar%20with%20stylus%20pen%20creative%20look%20simple%20background&width=100&height=100&seq=avatar-author-6&orientation=squarish',
    date: '2026-07-05',
    readTime: '8分钟',
    tags: ['同人小说', '二次创作', '社区'],
    views: 6230,
    likes: 1120,
    comments: 287,
    featured: false,
  },
];

export const heroSlides = [
  {
    id: 1,
    title: '2026夏季新番',
    subtitle: '霸权预定！最值得追的10部新番',
    bgImage: 'https://readdy.ai/api/search-image?query=vibrant%20anime%20collage%20with%20summer%20theme%20colorful%20characters%20in%20action%20poses%2C%20warm%20golden%20sunset%20background%2C%20energetic%20composition%2C%20Japanese%20anime%20promotional%20style%2C%20dynamic%20silhouettes%20with%20glowing%20effects&width=1600&height=700&seq=hero-slide-1&orientation=landscape',
    link: '/article/1',
  },
  {
    id: 2,
    title: 'Cosplay视觉盛宴',
    subtitle: '2026 ChinaJoy 大赛全程回顾',
    bgImage: 'https://readdy.ai/api/search-image?query=epic%20cosplay%20stage%20performance%20with%20elaborate%20costumes%20and%20dramatic%20colored%20spotlights%2C%20concert%20atmosphere%2C%20professional%20photography%2C%20energetic%20crowd%2C%20vibrant%20colors&width=1600&height=700&seq=hero-slide-2&orientation=landscape',
    link: '/article/12',
  },
  {
    id: 3,
    title: '漫画最终章',
    subtitle: '《咒术回战》结局深度解析',
    bgImage: 'https://readdy.ai/api/search-image?query=dark%20anime%20atmosphere%20with%20mystical%20purple%20and%20black%20energy%20swirls%2C%20dramatic%20manga%20panel%20style%20composition%2C%20intense%20supernatural%20mood%2C%20cinematic%20lighting%20with%20glowing%20accents&width=1600&height=700&seq=hero-slide-3&orientation=landscape',
    link: '/article/6',
  },
];

export const stats = [
  { value: '12.8万+', label: '注册用户' },
  { value: '5,200+', label: '原创文章' },
  { value: '380万+', label: '月浏览量' },
  { value: '9.5万+', label: '活跃同好' },
];

export const testimonials = [
  {
    id: 1,
    name: '樱花飘落',
    role: '资深动漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20female%20avatar%20with%20pink%20hair%20happy%20smile%20pastel%20background&width=100&height=100&seq=testimonial-1&orientation=squarish',
    content: '91次元是我每天必刷的二次元平台！番剧推荐特别及时，每次新番开播前就能看到详细的评测。社区氛围也很棒，认识了很多志同道合的朋友。',
  },
  {
    id: 2,
    name: '夜空之翼',
    role: '轻小说爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20male%20avatar%20with%20dark%20hair%20cool%20expression%20minimalist%20background&width=100&height=100&seq=testimonial-2&orientation=squarish',
    content: '作为一个轻小说控，91次元的轻小说推荐帮我挖到了很多宝藏作品。书评写得非常专业，每次都能找到下一本要追的书。',
  },
  {
    id: 3,
    name: '星之魔法师',
    role: 'Cosplay达人',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20girl%20avatar%20with%20twin%20tails%20and%20magical%20girl%20outfit%20cute%20expression%20soft%20pastel%20background&width=100&height=100&seq=testimonial-3&orientation=squarish',
    content: '从Cosplay入门到现在能独立完成整套服装制作，91次元的教程文章给了我超多帮助。平台上的Cosplay社区是我最喜欢的交流空间。',
  },
];